import { defineMessages } from 'react-intl';

export default defineMessages({
  head: {
    id: 'components.languageSuggest.head',
    defaultMessage: 'WE SPEAK YOUR LANGUAGE',
  },
  body: {
    id: 'components.languageSuggest.body',
    defaultMessage:
      'The Native Instruments website is also available in your language.',
  },
  linkText: {
    id: 'components.languageSuggest.linkText',
    defaultMessage: 'CHANGE LANGUAGE',
  },
});
